import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const Expense = () => {
  const data = [
    ['Category', 'Proportion'],
    ['On-Time', 80],
    ['Late', 20],
  ];

  const options = {
    title: 'Expense Submission Proportion',
    pieHole: 0.4,
    slices: [
      { color: '#4CAF50' },
      { color: '#F44336' },
    ],
    legend: { position: 'right' },
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="PieChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default Expense;